module.exports = __webpack_public_path__ + "img/han_site1_6f.e8c23658.png";